import invariant from 'invariant';

import { useEmbedSearchWidget } from 'modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import type { embedSearchWidgetViewOrgRoute } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';
import { listingApiHorizonFetchOrg } from 'modules/listing/api/org/listingApiFetchOrg';
import { NotFoundPageLoadable } from 'pages/NotFound/NotFoundPageLoadable';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetViewOrgPageLoadable } from './EmbedSearchWidgetViewOrgPageLoadable';

export async function loader({
  request,
  context,
  params: { orgId },
}: HorizonAppRouteLoaderArgs<typeof embedSearchWidgetViewOrgRoute>) {
  try {
    const [org] = await Promise.all([
      listingApiHorizonFetchOrg({ request, context })(orgId),
      EmbedSearchWidgetViewOrgPageLoadable.load(),
    ]);

    return { org };
  } catch {
    return { org: null };
  }
}

export default function EmbedSearchWidgetViewOrgHorizonRoute({
  loaderData: { org },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { embedSearchWidget } = useEmbedSearchWidget();
  invariant(embedSearchWidget, 'Embed search widget not set.');

  if (!org || org.type !== 'ORG') return <NotFoundPageLoadable />;

  return (
    <EmbedSearchWidgetViewOrgPageLoadable
      org={org}
      embedSearchWidget={embedSearchWidget}
    />
  );
}
